import React from "react";
import VehicleAddMoreLoanAmount from "./vehicleAddMoreLoanAmount";
import Accordion from "../../accordion";

function AddMoreLoanAmount(props: {}) {
    return (
        <>
            <div className="container mx-auto px-0 md:px-5">
                <div className="relative w-full">
                    <div className="accord-wrap">
                        <Accordion
                            open={true}
                            title="Add more to your loan amount"
                        >
                            <VehicleAddMoreLoanAmount />
                        </Accordion>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddMoreLoanAmount;
